import { GraviButton, MaterialIcon } from '@gravitate-js/excalibrr'
import { useQueryClient } from '@tanstack/react-query'
import { notification } from 'antd'
import { useState } from 'react'
import type { InvoiceGroup } from '../../../../../../api/useFreight/types'
import { useInvoices } from '../../../../../../api/useFreight/useInvoices'

export function RejectCreditButton({ invoiceGroup }: { invoiceGroup: InvoiceGroup }) {
  const { useRejectRebillMutation } = useInvoices()
  const rejectRebillMutation = useRejectRebillMutation()
  const [loading, setLoading] = useState(false)
  const queryClient = useQueryClient()
  const handleRejectCredit = async () => {
    setLoading(true)
    const rebillInvoice = invoiceGroup.invoices.find((invoice) => invoice.type === 'rebill')
    const creditInvoice = invoiceGroup.invoices.find((invoice) => invoice.type === 'credit')
    await rejectRebillMutation.mutateAsync({
      invoice_group_id: invoiceGroup.id,
      rebill_invoice_number: rebillInvoice?.invoice_number ?? '',
      credit_invoice_number: creditInvoice?.invoice_number ?? '',
    })
    queryClient.invalidateQueries({ queryKey: ['invoice'] })
    queryClient.invalidateQueries({ queryKey: ['invoices-be-query'] })
    notification.success({
      message: 'Credit/Rebill Rejected',
      description: `Credit/Rebill has been rejected for ${invoiceGroup?.counterparty_name} (${rebillInvoice?.invoice_number} / ${creditInvoice?.invoice_number}).`,
      placement: 'topRight',
      icon: <MaterialIcon icon='check_circle' style={{ color: 'var(--theme-success)' }} />,
    })
    setLoading(false)
  }
  return (
    <GraviButton
      error
      loading={loading}
      buttonText='Reject Credit/Rebill'
      onClick={handleRejectCredit}
      icon={<MaterialIcon icon='close' />}
    />
  )
}
